export default "/images/cdf4a476a0dff667e0e9bf88603063da.avif";